import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplyStackInput2Module, SupplyStackTopbarModule, SupplyStackTableModule, SupplyStackSelect2Module, SupplyStackPhoneInputModule, SupplyStackCountrySelectModule, SupplyStackSidebar2Module, SupplyStackDefaultPictureModule, SupplyStackDatepickerModule, SupplyStackTimepickerModule, SupplyStackExpandCardModule, SupplyStackLanguageSelectModule, SupplyStackPhoneInput2Module } from '@slickss/supplystack-components';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { BackModalComponent } from './components/back-modal/back-modal.component';
import { LoadingViewComponent } from './components/loading-view/loading-view.component';
import { ExpandPanelComponent } from './components/expand-panel/expand-panel.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CustomLoader } from '../_core/services/translation-loader.service';
import { UploadModalComponent } from './components/upload-modal/upload-modal.component';
import { FileUploadModule } from 'ng2-file-upload';
import { PartAssessementModalComponent } from './components/goods-part-assessement/goods-part-assessement.component';
import { HandlingGuidelinesModalComponent } from './components/goods-handling-guidelines/goods-handling-guidelines.component';
import { GridSetupModalComponent } from './components/grid-setup-modal/grid-setup-modal.component';
import { GridSetupModalService } from './components/grid-setup-modal/grid-setup-modal.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverflowDivComponent } from './components/overflow-div/overflow-div.component';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TimepickerModule } from './components/timepicker/timepicker.module';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { NumberInputDirective } from './directives/number-input.directive';

@NgModule({
    declarations: [
        AddressFormComponent,
        DeleteModalComponent,
        BackModalComponent,
        LoadingViewComponent,
        ExpandPanelComponent,
        GridSetupModalComponent,
        UploadModalComponent,
        PartAssessementModalComponent,
        HandlingGuidelinesModalComponent,
        OverflowDivComponent,
        NumberFormatPipe,
        NumberInputDirective
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SupplyStackTopbarModule,
        SupplyStackInput2Module,
        SupplyStackTableModule,
        SupplyStackSelect2Module,
        SupplyStackPhoneInputModule,
        SupplyStackCountrySelectModule,
        SupplyStackSidebar2Module,
        SupplyStackDefaultPictureModule,
        SupplyStackDatepickerModule,
        SupplyStackTimepickerModule,
        SupplyStackExpandCardModule,
        SupplyStackLanguageSelectModule,
        SupplyStackPhoneInput2Module,
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTableModule,
        MatTooltipModule,
        MatSlideToggleModule,
        AddressFormComponent,
        RecaptchaModule,
        DeleteModalComponent,
        LoadingViewComponent,
        ExpandPanelComponent,
        GridSetupModalComponent,
        OverflowDivComponent,
        TranslateModule,
        TimepickerModule,
        NumberFormatPipe,
        NumberInputDirective
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SupplyStackTopbarModule,
        SupplyStackInput2Module,
        SupplyStackTableModule,
        SupplyStackSelect2Module,
        SupplyStackPhoneInputModule,
        SupplyStackCountrySelectModule,
        SupplyStackSidebar2Module,
        SupplyStackDefaultPictureModule,
        SupplyStackDatepickerModule,
        SupplyStackTimepickerModule,
        SupplyStackExpandCardModule,
        SupplyStackLanguageSelectModule,
        SupplyStackPhoneInput2Module,
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatTableModule,
        MatTooltipModule,
        MatRadioModule,
        MatSlideToggleModule,
        RecaptchaModule,
        FileUploadModule,
        DragDropModule,
        TranslateModule.forChild({
            loader: { provide: TranslateLoader, useClass: CustomLoader },
        }),
        TimepickerModule
    ],
    providers: [
        GridSetupModalService
    ]
})
export class SharedModule { }
